import DateTimePickerComponent from '@cp/src/components/DateTimePicker/DateTimePickerComponent';
import { DATE_TIME_TYPE } from '@cp/src/components/DateTimePicker/constants';
import { DateFormat, dateFormat } from '@cp/src/utils/DateHelper';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { TextArea, Typography } from '@navi/web-ui/lib/primitives';
import { Controller, useForm } from 'react-hook-form';
import { COMMENT_VALIDATIONS } from '../../constants';
import {
  getAnomalyTickets,
  getSingleAnomalyTicket,
  updateAnomaly
} from '../../actions/AnomalyTrackerAction';
import { useDispatch } from 'react-redux';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { AnomalyStatus, AnomalyTableKeys, IEtaDefaultValues } from '../../types';
import AnomalySubmitCta from './AnomalySubmitCta';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

const ETA = () => {
  const dispatch = useDispatch();
  const params = readQueryParams();
  const selectedAnomalyId = params?.[AnomalyTableKeys.ANOMALY_TABLE_ACTION]?.selectedId;

  const {
    watch,
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm<IEtaDefaultValues>({
    defaultValues: {
      at: '',
      reason: ''
    }
  });

  const getLastDateOfNextMonth = () => {
    const todaysDate = new Date();
    const nextMonth = new Date(todaysDate.getFullYear(), todaysDate.getMonth() + 1, 1);
    const lastDateOfNextMonth = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0);
    return lastDateOfNextMonth;
  };

  const etaDate = watch('at');
  const today = dateFormat(new Date(), DateFormat.ISO_DATE_FORMAT);
  const maxDate = dateFormat(getLastDateOfNextMonth(), DateFormat.ISO_DATE_FORMAT);
  const successCallback = () => {
    reset();
    dispatch(getSingleAnomalyTicket(selectedAnomalyId));
    dispatch(getAnomalyTickets(AnomalyStatus.OPEN, params?.openAnomalyTable, false));
  };

  const submitETA = (data: IEtaDefaultValues) => {
    addClickstreamEvent(
      CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_ANOMALY_ETA_SUBMIT_BUTTON_CLICKED,
      {
        anomalyId: selectedAnomalyId,
        data
      }
    );
    dispatch(updateAnomaly(selectedAnomalyId, { eta: data }, successCallback));
  };

  return (
    <>
      <form className="p-6 overflow-scroll m-0">
        <div className="flex items-center mb-2">
          <Typography color="var(--grayscale-2)" variant="p4">
            Select ETA Date
          </Typography>
          <RequiredIcon className="mt-[-8px] ml-1" />
        </div>

        <Controller
          control={control}
          name="at"
          render={({ field: { onChange, value } }) => (
            <DateTimePickerComponent
              type={DATE_TIME_TYPE.DATE}
              min={today}
              max={maxDate}
              value={value}
              onChange={onChange}
              className="mb-4"
              containerClasses="!w-full"
              required
              updateDateLabel
            />
          )}
        />
        <Controller
          control={control}
          name="reason"
          rules={COMMENT_VALIDATIONS}
          render={({ field: { onChange, value } }) => (
            <TextArea
              label="Reason for ETA"
              rows={5}
              containerClassName="w-full"
              placeholder="Leave a comment..."
              onChange={onChange}
              value={value}
              error={errors?.reason?.message}
            />
          )}
        />
      </form>
      <AnomalySubmitCta disabled={!etaDate} onSubmit={handleSubmit(submitETA)} />
    </>
  );
};

export default ETA;
